var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.productData)?_c('div',{staticClass:"text-body-2"},[_c('span',{staticClass:"mr-4"},[_vm._v(_vm._s(_vm.productData.articleNumber))]),_vm._v(" "+_vm._s(_vm.productData.productName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }